/**
 * Modal para abrir la URL del botón CTA del banner de campaña dentro de la
 * app (HU-019) — se usa solo cuando `campana_cta_modal` está activo. Si el
 * sitio de destino no permite ser embebido (cabecera `X-Frame-Options`), el
 * navegador lo deja en blanco: en ese caso conviene desactivar el modal y
 * abrir la URL en pestaña nueva.
 */
const ModalCta = ({ url, onCerrar }) => {
  if (!url) return null;

  return (
    <div className="cn-modal-cta" onClick={onCerrar}>
      <div className="cn-modal-cta-caja" onClick={(e) => e.stopPropagation()}>
        <div className="cn-modal-cta-barra">
          <span className="cn-modal-cta-titulo">Contenido</span>
          <button type="button" className="cn-modal-cta-cerrar" onClick={onCerrar} aria-label="Cerrar">
            <i className="fas fa-times"></i>
          </button>
        </div>
        <iframe className="cn-modal-cta-frame" src={url} title="Contenido de la campaña" />
      </div>
    </div>
  );
};

export default ModalCta;
